export const SET_IS_NEW = 'CHECKLIST/SET_IS_NEW';
export const SET_SELECTED_LOCALE = 'CHECKLIST/SET_SELECTED_LOCALE';
export const SET_DISPLAYED_LANGUAGES = 'CHECKLIST/SET_DISPLAYED_LANGUAGES';

export const MULTIPLE_FETCH_REQUEST = 'CHECKLISTS/FETCH_REQUEST';
export const MULTIPLE_FETCH_SUCCESS = 'CHECKLISTS/FETCH_SUCCESS';
export const MULTIPLE_FETCH_FAILURE = 'CHECKLISTS/FETCH_FAILURE';

export const FETCH_REQUEST = 'CHECKLIST/FETCH_REQUEST';
export const FETCH_SUCCESS = 'CHECKLIST/FETCH_SUCCESS';
export const FETCH_FAILURE = 'CHECKLIST/FETCH_FAILURE';

export const UPDATE_REQUEST = 'CHECKLIST/UPDATE_REQUEST';
export const UPDATE_SUCCESS = 'CHECKLIST/UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'CHECKLIST/UPDATE_FAILURE';

export const CREATE_REQUEST = 'CHECKLIST/CREATE_REQUEST';
export const CREATE_SUCCESS = 'CHECKLIST/CREATE_SUCCESS';
export const CREATE_FAILURE = 'CHECKLIST/CREATE_FAILURE';

export const PATCH_ADVICE = 'CHECKLIST/ADVICE/PATCH_REQUEST';
export const PATCH_ADVICE_SUCCESS = 'CHECKLIST/ADVICE/PATCH_SUCCESS';
export const PATCH_ADVICE_FAILURE = 'CHECKLIST/ADVICE/PATCH_FAILURE';

export const PATCH_ADVICE_STATE = 'CHECKLIST/ADVICE/STATE/PATCH_REQUEST';
export const PATCH_ADVICE_STATE_SUCCESS = 'CHECKLIST/ADVICE/STATE/PATCH_SUCCESS';
export const FETCH_CHECKLIST_ADVICE_HISTORY = 'CHECKLIST/ADVICE/HISTORY/FETCH_REQUEST';
export const FETCH_CHECKLIST_ADVICE_HISTORY_SUCCESS = 'CHECKLIST/ADVICE/HISTORY/FETCH_SUCCESS';

export const APPLICATION_IS_READY = 'CHECKLIST/LOADED/SUCCESS';

export const TOGGLE_OPEN_CHECKLIST = 'CHECKLISTS/CHECKLIST/COLLAPSE/TOGGLE';
export const OPEN_CHECKLIST = 'CHECKLISTS/CHECKLIST/COLLAPSE/OPEN';
export const CLOSE_CHECKLIST = 'CHECKLISTS/CHECKLIST/COLLAPSE/CLOSE';

export const OPEN_CHECKLISTS = 'CHECKLISTS/CHECKLISTS/COLLAPSE/OPEN';
export const CLOSE_CHECKLISTS = 'CHECKLISTS/CHECKLISTS/COLLAPSE/CLOSE';
export const CLOSE_ALL_CHECKLISTS = 'CHECKLISTS/CHECKLISTS/COLLAPSE/ALL/CLOSE';

export const OPEN_ITEM = 'ITEMS/ITEM/COLLAPSE/OPEN';
export const CLOSE_ITEM = 'ITEMS/ITEM/COLLAPSE/CLOSE';

export const OPEN_ITEMS = 'ITEMS/ITEMS/COLLAPSE/OPEN';
export const CLOSE_ITEMS = 'ITEMS/ITEMS/COLLAPSE/CLOSE';
export const CLOSE_ALL_ITEMS = 'ITEMS/COLLAPSE/ALL/CLOSE';

export const SEARCH_CHECKLISTS_REQUEST = 'CHECKLISTS/SEARCH/FETCH_CHECKLISTS_REQUEST';
export const SEARCH_CHECKLISTS_FAILURE = 'CHECKLISTS/SEARCH/FETCH_CHECKLISTS_FAILURE';
export const SEARCH_CHECKLISTS_SUCCESS = 'CHECKLISTS/SEARCH/FETCH_CHECKLISTS_SUCCESS';

export const DELETE_CHECKLIST_REQUEST = 'DELETE_CHECKLIST_REQUEST';
export const DELETE_CHECKLIST_SUCCESS = 'DELETE_CHECKLIST_SUCCESS';
export const DELETE_CHECKLIST_FAILURE = 'DELETE_CHECKLIST_FAILURE';

export const FETCH_CHECKLISTS_SELECT_REQUEST = 'FETCH_CHECKLISTS_SELECT_REQUEST';
export const FETCH_CHECKLISTS_SELECT_FAILURE = 'FETCH_CHECKLISTS_SELECT_FAILURE';
export const FETCH_CHECKLISTS_SELECT_SUCCESS = 'FETCH_CHECKLISTS_SELECT_SUCCESS';

export const FETCH_DEFAULT_CHECKLIST_REQUEST = 'FETCH_DEFAULT_CHECKLIST_REQUEST';
export const FETCH_DEFAULT_CHECKLIST_FAILURE = 'FETCH_DEFAULT_CHECKLIST_FAILURE';
export const FETCH_DEFAULT_CHECKLIST_SUCCESS = 'FETCH_DEFAULT_CHECKLIST_SUCCESS';

export const CLEAN_CHECKLISTS_SELECT = 'CLEAN_CHECKLISTS_SELECT';
export const CLEAN_CHECKLISTS = 'CLEAN_CHECKLISTS';
export const DISPLAY_CHECKLIST_DUPLICATE_MODAL = 'DISPLAY_CHECKLIST_DUPLICATE_MODAL';
export const HIDE_CHECKLIST_DUPLICATE_MODAL = 'HIDE_CHECKLIST_DUPLICATE_MODAL';

export const CREATE_CHECKLIST_FROM_DEFAULT_CHECKLIST = 'CHECKLIST/CREATE_FROM_DEFAULT';

export const DUPLICATE_CHECKLIST_REQUEST = 'CHECKLIST/DUPLICATE_REQUEST';
export const DUPLICATE_CHECKLIST_SUCCESS = 'CHECKLIST/DUPLICATE_SUCCESS';
export const DUPLICATE_CHECKLIST_FAILURE = 'CHECKLIST/DUPLICATE_FAILURE';

export const FETCH_SELECTED_CHECKLISTS_REQUEST = 'CHECKLISTS/FETCH/SELECTED/REQUEST';
export const FETCH_SELECTED_CHECKLISTS_SUCCESS = 'CHECKLISTS/FETCH/SELECTED/SUCCESS';
export const FETCH_SELECTED_CHECKLISTS_FAILURE = 'CHECKLISTS/FETCH/SELECTED/FAILURE';
